export default {
  title: 'Prodotti in evidenza',
};
